import { FormlyModule } from '@ngx-formly/core';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatProgressBarModule } from '@angular/material/progress-bar';

import { TranslationModule } from '@lib/translation';

import { SearchListFormFieldComponent } from './components/form-field/search-list-form-field.component';

@NgModule({
  imports: [
    // Angular
    CommonModule,
    ReactiveFormsModule,
    
    // Material
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatListModule,
    MatCheckboxModule,
    MatButtonModule,
    MatProgressBarModule,
    
    // Transloco
    TranslationModule,
    
    // Formly
    FormlyModule.forChild({
      types: [
        {
          name: 'search-list',
          component: SearchListFormFieldComponent,
          wrappers: ['form-field'],
        },
      ],
    }),
  ],
  declarations: [SearchListFormFieldComponent],
  exports: [SearchListFormFieldComponent],
})
export class SnFormSearchListModule {}
